import api from "./api";
import { IAtributo, IAtributoCreate } from "interfaces/loja/atributosProduto";
import { PaginatedResponse } from "interfaces/paginatedResponse";
import { ENDPOINTS } from "./endPoints";

// API: Listar atributos do produto
export async function getAllAtributos(
  page: number = 1,
  limit: number = 100
): Promise<{ data: PaginatedResponse<IAtributo>; status: number }> {
  const { url, method } = ENDPOINTS.LOJA.ATRIBUTOS.LISTAR_ALL;
  try {
    const { data, status } = await api({
      url: url(page, limit),
      method: method,
    });
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Cadastrar um atributo do produto
export async function createAtributo(
  data: IAtributoCreate
): Promise<{ data: IAtributo; status: number }> {
  const { url, method } = ENDPOINTS.LOJA.ATRIBUTOS.CRIAR;
  try {
    const { data: responseData, status } = await api({
      url: url,
      method: method,
      data: data,
    });
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Editar um atributo do produto
export async function updateAtributo(atributoId: string, data: any) {
  try {
    const { data: responseData, status } = await api.put(
      `/loja/atributos/${atributoId}`,
      data
    );
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Deletar um atributo do produto
export async function deleteAtributo(atributoId: string) {
  try {
    const { data, status } = await api.delete(`/loja/atributos/${atributoId}`);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Adicionar opções ao atributo do produto
export async function addOpcaoToAtributo(atributoId: string, data: any) {
  try {
    const { data: responseData, status } = await api.post(
      `/loja/atributos/${atributoId}/opcoes`,
      data
    );
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Atualizar uma opção do atributo do produto (backend usa /loja/atributos/opcoes/:opcaoId)
export async function updateOpcaoAtributo(
  _atributoId: string,
  opcaoId: string,
  data: any
) {
  try {
    const { data: responseData, status } = await api.put(
      `/loja/atributos/opcoes/${opcaoId}`,
      data
    );
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

// API: Deletar uma opção do atributo do produto (backend usa /loja/atributos/opcoes/:opcaoId)
export async function deleteOpcaoAtributo(_atributoId: string, opcaoId: string) {
  try {
    const { data, status } = await api.delete(
      `/loja/atributos/opcoes/${opcaoId}`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
